import { useState, useEffect } from "react";

export default function PageTransition({ isTransitioning, children }) {
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    if (isTransitioning) {
      setVisible(false);
    } else {
      const t = setTimeout(() => setVisible(true), 50);
      return () => clearTimeout(t);
    }
  }, [isTransitioning]);

  return (
    <div
      style={{
        opacity: visible ? 1 : 0,
        transform: visible ? "translateY(0)" : "translateY(20px)",
        transition: "opacity 0.5s cubic-bezier(0.16, 1, 0.3, 1), transform 0.5s cubic-bezier(0.16, 1, 0.3, 1)",
      }}
    >
      {children}
    </div>
  );
}
